import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import * as Session from './Session'
import * as Facility from './Facility'
import * as Events from './Events'
import * as Staff from './Staff'
import * as Venue from './Venue'
import * as Reservation from './Reservations'
import * as Config from './Config'
import * as PaymentLinks from './PaymentLinks'

export default function configureStore(history, initialState) {
    const reducers = {
        facility: Facility.reducer,
        session: Session.reducer,
        events: Events.reducer,
        staff: Staff.reducer,
        venue: Venue.reducer,
        reservation: Reservation.reducer,
        config: Config.reducer,
        paymentLinks: PaymentLinks.reducer,
    }

    const middleware = [thunk, routerMiddleware(history)]

    // In development, use the browser's Redux dev tools extension if installed
    const enhancers = []
    const isDevelopment = process.env.NODE_ENV === 'development'
    if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
        enhancers.push(window.devToolsExtension())
    }

    const rootReducer = combineReducers({
        ...reducers,
    })

    return createStore(
        connectRouter(history)(rootReducer),
        initialState,
        compose(
            applyMiddleware(...middleware),
            ...enhancers
        )
    )
}
